export default "__VITE_ASSET__jAa2gikO__"